/**
 * Andockstelle für die Socket-Anbindung der App-Shell: Die Shell ruft nach dem Verbinden
 * `bindVoiceSocket(socket)` auf (und optional `seedVoiceStates(ready.voiceStates)`), damit Vorschau, Taub-Anzeige und
 * serverseitiges Trennen/Verschieben live ankommen. Ohne Anbindung fragt die Voice-Ansicht die Zustände per REST ab.
 */
import type { VoiceStateDto } from '@lagerfeuer/shared';
import type { LfSocket } from '../../lib/socket';
import { getVoiceController } from './controller';
import type { VoiceStateUpdate } from './logic';

export function bindVoiceSocket(socket: Pick<LfSocket, 'on' | 'off'>): () => void {
  const onUpdate = (p: VoiceStateUpdate) => getVoiceController().handleStateUpdate(p);
  socket.on('VOICE_STATE_UPDATE', onUpdate);
  return () => {
    socket.off('VOICE_STATE_UPDATE', onUpdate);
  };
}

export function seedVoiceStates(states: VoiceStateDto[]): void {
  getVoiceController().seedStates(states);
}
